import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Text, IconButton, Badge, Link } from "@chakra-ui/react";
import { FaEdit, FaEye, FaEyeSlash, FaExternalLinkAlt } from "react-icons/fa";
import { memo } from "react";
import { LINK_TYPE_LABELS } from "../../constants/linkTypes";
import { stickyColHeaderProps, stickyColCellProps } from "../../constants/tableStyles";

const LinkTable = ({ links, onEdit, onDeactivate }) => {
    if (links.length === 0) {
        return <Text align="center" color="gray.500">Nema poveznica. Dodajte prvu poveznicu.</Text>;
    }

    const sortedLinks = [...links].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    return (
        <TableContainer overflowX="auto">
            <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                    <Tr>
                        <Th {...stickyColHeaderProps}>#</Th>
                        <Th>Naziv</Th>
                        <Th>Tip</Th>
                        <Th>URL</Th>
                        <Th isNumeric>Redoslijed</Th>
                        <Th>Status</Th>
                        <Th>Akcije</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {sortedLinks.map((link, index) => (
                        <Tr key={link.id} _hover={{ bg: "brand.50" }}>
                            <Td {...stickyColCellProps(index % 2 === 0)}>{index + 1}</Td>
                            <Td fontWeight="bold">{link.name}</Td>
                            <Td>{LINK_TYPE_LABELS[link.type] ?? link.type}</Td>
                            <Td maxW="260px">
                                {link.url ? (
                                    <Link href={link.url} isExternal color="brand.600" display="flex" alignItems="center" gap={1}>
                                        <Text as="span" noOfLines={1}>{link.url}</Text>
                                        <FaExternalLinkAlt size={11} />
                                    </Link>
                                ) : (
                                    <Text color="gray.400">-</Text>
                                )}
                            </Td>
                            <Td isNumeric>{link.order}</Td>
                            <Td>
                                <Badge colorScheme={link.isActive ? "green" : "red"}>
                                    {link.isActive ? "Aktivno" : "Neaktivno"}
                                </Badge>
                            </Td>
                            <Td>
                                <IconButton
                                    icon={<FaEdit />}
                                    size="sm"
                                    mr={2}
                                    aria-label="Uredi poveznicu"
                                    onClick={() => onEdit(link)}
                                />
                                <IconButton
                                    icon={link.isActive ? <FaEyeSlash /> : <FaEye />}
                                    size="sm"
                                    aria-label={link.isActive ? "Deaktiviraj poveznicu" : "Aktiviraj poveznicu"}
                                    onClick={() => onDeactivate(link)}
                                />
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
};

export default memo(LinkTable);
